import type { WorkChipView } from "@/lib/attributeReview/rowChips";
import { cn } from "@/lib/utils";

const TONE: Record<WorkChipView["tone"], string> = {
  amber: "bg-amber-50 text-amber-800 dark:bg-amber-950/40 dark:text-amber-200",
  quiet: "bg-slate-100 text-slate-600 dark:bg-slate-800 dark:text-slate-300",
  draft:
    "bg-indigo-50 text-indigo-700 dark:bg-indigo-950/40 dark:text-indigo-300",
  system: "bg-sky-50 text-sky-800 dark:bg-sky-950/40 dark:text-sky-200",
};

export function WorkChip({ chip }: { chip: WorkChipView }) {
  return (
    <span
      className={cn(
        "rounded px-1.5 py-0.5 text-xs font-medium [overflow-wrap:anywhere]",
        TONE[chip.tone],
      )}
    >
      {chip.text}
    </span>
  );
}
